export default class TextCountdown {
  constructor(el) {
    this.el = el;
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    const fieldsSelector = this.el.getAttribute('data-fields-selector');
    const fields2count = this.el.querySelectorAll(fieldsSelector);
    fields2count.forEach(f2c => {
      const maxL = f2c.getAttribute('maxlength');
      const cBox = f2c.parentElement.nextElementSibling;
      const cBoxOutput = cBox.querySelector('span');
      cBoxOutput.innerHTML = maxL - f2c.value.length;
      f2c.addEventListener('keyup', () => {
        cBoxOutput.innerHTML = maxL - f2c.value.length;
      });
    });
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/text_countdown.js